export const LOCAL_STORAGE_AUTH_KEY = 'auth-react';
export const LOCAL_STORAGE_COUNT_DOWN_TIME = 'count-down-time';
export const LOCAL_STORAGE_MENU_COLLAPSED = 'menu-collapsed';
export const LOCAL_STORAGE_DEVICE_SETTING_CHART = 'device-setting-chart-21/12/2023';
